export default __webpack_public_path__ + "static/media/image 2.66d32a74.png";